import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

/**
 * Click-to-switch storytelling component.
 *
 * Headings are always visible in a vertical accordion list. Clicking a
 * heading crossfades in its image and expands its description — a plain
 * state toggle, with no scroll-driven pinning involved.
 *
 * @extends {Component}
 */
export class AuthenticityScrollStoryComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.navItems = Array.from(this.querySelectorAll('[data-story-nav-item]'));
    this.mediaItems = Array.from(this.querySelectorAll('[data-story-media-item]'));
    this.activeIndex = -1;

    if (prefersReducedMotion()) {
      this.classList.add('authenticity-story--reduced-motion');
    }

    // Reflect the initial step (matches the server-rendered first-item
    // state, but also sets aria-expanded).
    this.setActive(0);
  }

  /**
   * Handles a click on a heading trigger.
   *
   * @param {{ index: number }} data
   */
  activateStep(data) {
    const index = Number(data?.index) || 0;
    this.setActive(index);
  }

  /**
   * @param {number} index
   */
  setActive(index) {
    if (index === this.activeIndex) return;

    this.activeIndex = index;

    this.navItems.forEach((el, i) => {
      const isActive = i === index;
      el.classList.toggle('is-active', isActive);

      const trigger = el.querySelector('[data-story-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', String(isActive));
    });

    this.mediaItems.forEach((el, i) => el.classList.toggle('is-active', i === index));
  }
}

if (!customElements.get('authenticity-scroll-story-component')) {
  customElements.define('authenticity-scroll-story-component', AuthenticityScrollStoryComponent);
}
